import React, { useEffect, useState } from 'react';
import Header from '@components/Comman/Header';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useDispatch } from 'react-redux';
import { getAllAdminNotificationCount, getAllReferUs, updateReferrerNotificationCount } from '../../actions/refer';
import { useSelector } from 'react-redux';
import moment from 'moment';
import SearchFilter from '@components/Comman/TableFilter/SearchFilter';
import { isValidEmail } from '@utils/comman';

interface DataType {
    key: string;
    companyName: string;
    contactName: string;
    email: string;
    contactNumber: string;
    isRegistered: boolean;
}

interface PayloadType {
    limit: number;
    page: number;
};

interface ReferralsType {
    adminId?: number
}

const ReferUsList = ({ adminId }: ReferralsType) => {
    const [data, setData] = useState<DataType[]>([]);
    const [pagination, setPagination] = useState({ totalItems: 0 });
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();
    const { isLoading } = useSelector((state: any) => state?.General);
    const userData = useSelector((state: any) => state?.Auth?.user);
    const userRoleId = userData?.data?.roleId;

    const columns: ColumnsType<DataType> = [
        {
            title: 'Date Referred',
            dataIndex: 'createdAt',
            key: 'createdAt',
            sorter: (a: any, b: any) => a.createdAt.localeCompare(b.createdAt),
            render: (text) => <>{moment(text).format('DD/MM/YYYY')}</>,
            align: 'left',
            width: 130,
        },
        {
            title: 'Business Name',
            dataIndex: 'companyName',
            key: 'companyName',
            sorter: (a, b) => a.companyName.localeCompare(b.companyName),
            render: (text) => <>{text}</>,
            align: 'left',
            width: 200,
        },
        {
            title: 'Contact Name',
            dataIndex: 'contactName',
            key: 'contactName',
            sorter: (a, b) => a.contactName.localeCompare(b.contactName),
            render: (text) => <>{text}</>,
            align: 'left',
            width: 150,
        },
        {
            title: 'Contact Number',
            dataIndex: 'contactNumber',
            key: 'contactNumber',
            render: (text) => <>{text}</>,
            align: 'center',
            width: 150,
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            sorter: (a, b) => a.email.localeCompare(b.email),
            render: (text) => <>{text}</>,
            align: 'left',
            width: 200,
        },
        {
            title: 'Referred By',
            dataIndex: 'admin',
            key: 'admin',
            render: (res) => <>{ (res) ? res?.contactName : 'Open' }</>,
            align: 'center',
            width: 150,
        },
        // {
        //     title: 'Action',
        //     align: 'center',
        //     key: 'action', // type='link' onClick={() => navigate('/myreferrals', { replace: true, state: { isView: true, record } })}
        //     render: (_, record) => (
        //         <Popconfirm title="Are you sure you want to delete ?" onConfirm={() => console.log("Delete this")} onCancel={() => console.log("Not sure")}>
        //             <DeleteFilled style={{ color: 'rgb(244, 117, 35)', cursor: 'pointer'}} />
        //         </Popconfirm>
        //     ),
        // }
    ];


    const getReferralData =(payload: any)=> {
        payload = {
            page,
            ...payload,
            limit: pageSize,
        };

        dispatch(            
            getAllReferUs(payload, (resp: any) => {                
                if (resp?.status === 200) {
                    setData(resp?.data);
                    setPagination(resp?.pagination);
                }
            })
        );
    }

    useEffect(() => {
        let payload: PayloadType = {
            limit: pageSize, page
        };
        getReferralData(payload);
    }, [page, pageSize, dispatch]);

    useEffect(()=> {
        dispatch(updateReferrerNotificationCount({resetType: 'refer', role: userRoleId }, (res:any)=>{
            dispatch(getAllAdminNotificationCount({}, (res:any)=>{}))
        }))
    }, [])


    const handleTableChange = (pagination: any) => {
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const tableComponent = (
        <div className="responsivetable">
            <Table
                size='small'
                columns={columns}
                dataSource={data}
                loading={isLoading}
                pagination={{
                    total: pagination?.totalItems || 0,
                    pageSize,
                    current: page,
                    showSizeChanger: true,
                    pageSizeOptions: ['20', '50'],
                }}
                scroll={{ y: 284, x: 900 }}
                onChange={handleTableChange}
                rowKey='email'
            />
        </div>
    );

    const handleSearch =(data:any)=> {
        let payload = {
            ...data,
            search: data?.search,
            email: data?.search,
            page: 1
        }
        if(isValidEmail(payload?.search)) {
           delete payload.search
        } else {
            delete payload.email
        }
        getReferralData(payload);
    }

    const advanceFilterReferUsList = [
        { value: "companyName", label: "Business Name" },
        { value: "contactName", label: "Contact Name" },
    ];

    return (
        <div>
            <Header pagTitle="Refer ReferUs" />
            <div className="contentBody">
                <div className="bodycard">
                    <div className="bodycardheading"></div>
                    <div className='pl-24' style={{ float: "right" }}>
                    </div>
                    <div className=''>
                        <SearchFilter
                            searchTitle="Business Name, Contact Name"
                            filterList={advanceFilterReferUsList}
                            onSearch={(searchValue, ) => {
                                // Handle the search value here
                                console.log(searchValue);
                                handleSearch(searchValue)
                            }}
                        />
                    </div>

                    <div className="cardContentbody">
                        {tableComponent}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReferUsList;
